/** @format */

export const DEFAULT_TEST_ID = 'formatted-condition';
